var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico-home",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18.767,
    viewBox: "0 0 18 18.767",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15356",
    "data-name": "Grupo 15356",
    transform: "translate(-340 -396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15342",
    "data-name": "Grupo 15342",
    transform: "translate(286 59)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15328",
    "data-name": "Grupo 15328",
    transform: "translate(1.83 1.036)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15324",
    "data-name": "Grupo 15324",
    transform: "translate(52.17 335.964)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15240",
    "data-name": "Grupo 15240"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14504",
    "data-name": "Caminho 14504",
    d: "M23.588,15.224a.9.9,0,0,0-1.176,0l-6.3,5.434a.9.9,0,0,0-.312.682v7.31a.9.9,0,0,0,.9.9h.992a.9.9,0,0,1,0,1.8H16.7a2.7,2.7,0,0,1-2.7-2.7v-7.31a2.7,2.7,0,0,1,.937-2.045l6.3-5.434a2.7,2.7,0,0,1,3.527,0l6.3,5.434A2.7,2.7,0,0,1,32,21.339v7.31a2.7,2.7,0,0,1-2.7,2.7H28.135a.9.9,0,0,1,0-1.8H29.3a.9.9,0,0,0,.9-.9v-7.31a.9.9,0,0,0-.312-.682Z",
    transform: "translate(-14 -13.205)",
    fill: "#1c787e",
    fillRule: "evenodd"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14505",
    "data-name": "Caminho 14505",
    d: "M48.934,69.146V65.318a1.616,1.616,0,1,0-3.233,0v3.828ZM47.318,62A3.318,3.318,0,0,0,44,65.318V70a.851.851,0,0,0,.851.851h4.934A.851.851,0,0,0,50.636,70V65.318A3.318,3.318,0,0,0,47.318,62Z",
    transform: "translate(301.715 343.919)",
    fill: "#1c787e",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoHome);
export default __webpack_public_path__ + "static/media/ico-home.db0a44123da52fba12bbe3bc5fe9b201.svg";
export { ForwardRef as ReactComponent };